exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".what-this[data-v-7abbe37e] {\n  position: absolute;\n  right: 10px;\n  top: 64px;\n  cursor: pointer;\n  font-size: 13px;\n}\n.form-four > div[data-v-7abbe37e] {\n  width: calc(25% - 18px);\n}\n@media screen and (max-width: 760px) {\n.form-four > div[data-v-7abbe37e] {\n    width: 100%;\n}\n}", ""]);

// exports
